/* FIRE Number Calculator — Ch. 22. */
(function () {
  'use strict';
  function fmt(n) { return '$' + Math.round(n).toLocaleString('en-US'); }

  class FireNumber {
    constructor(id) {
      this.el = document.getElementById(id); if (!this.el) return;
      var u = IT.url.read();
      this.state = {
        monthlyExp:  +u.exp || 2000,
        retRate:     +u.rr  || 7,
        currentAge:  +u.ca  || 17,
        targetAge:   +u.ta  || 45,
        currentSav:  +u.cs  || 0,
        monthlySav:  +u.ms  || 200
      };
      this.render(); this.bind(); this.update();
    }
    field(label, key, type, opts) {
      var disp = opts.fmt ? opts.fmt(opts.val) : opts.val;
      return `<div class="sim-field">
        <label class="sim-field__label"><span>${label}</span><span class="val" data-display="${key}">${disp}</span></label>
        <input type="${type}" data-state="${key}" min="${opts.min}" max="${opts.max}" step="${opts.step}" value="${opts.val}">
      </div>`;
    }
    render() {
      var s = this.state;
      this.el.innerHTML = `
        <div class="sim-layout">
          <div class="sim-controls">
            ${this.field('Monthly expenses (in retirement)', 'monthlyExp', 'range', { min: 500, max: 10000, step: 100, val: s.monthlyExp, fmt: fmt })}
            ${this.field('Expected return in retirement', 'retRate', 'range', { min: 3, max: 10, step: 0.25, val: s.retRate, fmt: v => v + '%' })}
            ${this.field('Current age', 'currentAge', 'range', { min: 13, max: 60, step: 1, val: s.currentAge, fmt: v => v })}
            ${this.field('Target FIRE age', 'targetAge', 'range', { min: 25, max: 70, step: 1, val: s.targetAge, fmt: v => v })}
            ${this.field('Current savings', 'currentSav', 'range', { min: 0, max: 100000, step: 500, val: s.currentSav, fmt: fmt })}
            ${this.field('Monthly savings', 'monthlySav', 'range', { min: 25, max: 5000, step: 25, val: s.monthlySav, fmt: fmt })}
          </div>
          <div class="sim-results">
            <div class="sim-result">
              <div class="sim-result-label">Your FIRE Number</div>
              <div class="sim-result-primary" data-out="fire">$0</div>
              <div class="sim-result__sub" data-out="firesub"></div>
            </div>
            <div style="display:grid; grid-template-columns:1fr 1fr; gap:12px;">
              <div class="sim-result"><div class="sim-result-label">4% Annual withdrawal</div><div style="font-family:var(--font-display); font-weight:700; font-size:22px;" data-out="withdraw">$0</div></div>
              <div class="sim-result"><div class="sim-result-label">Time to FIRE</div><div style="font-family:var(--font-display); font-weight:700; font-size:22px;" data-out="time">—</div></div>
            </div>
            <div>
              <p class="label">PROGRESS</p>
              <div style="height:14px; background:var(--border); margin:8px 0;"><div data-out="bar" style="height:100%; background:var(--yellow); width:0%;"></div></div>
              <p class="sim-result__sub" data-out="barsub"></p>
            </div>
            <div class="sim-chart-wrap"><canvas id="fire-chart"></canvas></div>
            <div class="sim-insight">The 4% Rule (Trinity Study, 1998): a $1M portfolio can safely provide $40,000/year and has lasted 30+ years in all historical scenarios.</div>
            <div class="sim-insight">The Rule of 25: FIRE Number = 25 × annual spending.</div>
          </div>
        </div>`;
    }
    bind() {
      this.el.querySelectorAll('input[data-state]').forEach(input => {
        input.addEventListener('input', () => {
          var k = input.dataset.state, v = +input.value;
          this.state[k] = v;
          var l = this.el.querySelector(`[data-display="${k}"]`);
          if (l) {
            if (k === 'retRate') l.textContent = v + '%';
            else if (k === 'currentAge' || k === 'targetAge') l.textContent = v;
            else l.textContent = fmt(v);
          }
          this.update();
        });
      });
    }
    project(years, pv, pmt, ratePct) {
      var r = ratePct / 100 / 12, n = years * 12;
      return pv * Math.pow(1 + r, n) + pmt * ((Math.pow(1 + r, n) - 1) / r);
    }
    update() {
      var s = this.state;
      var annualExp = s.monthlyExp * 12;
      var fire = annualExp * 25;
      var growthRate = 8; // accumulation phase assumption
      // years until FIRE solving for time
      var yearsToFire = -1;
      for (var y = 0; y <= 70; y++) {
        var proj = this.project(y, s.currentSav, s.monthlySav, growthRate);
        if (proj >= fire) { yearsToFire = y; break; }
      }
      var $ = q => this.el.querySelector(q);
      $('[data-out="fire"]').textContent = fmt(fire);
      $('[data-out="firesub"]').textContent = `(25× annual expenses of ${fmt(annualExp)})`;
      $('[data-out="withdraw"]').textContent = fmt(fire * 0.04);

      var fireAge = (yearsToFire >= 0) ? (s.currentAge + yearsToFire) : null;
      $('[data-out="time"]').textContent = (fireAge !== null)
        ? `${yearsToFire} yr — age ${fireAge}`
        : 'beyond 70 yr';

      var pct = Math.min(100, (s.currentSav / fire) * 100);
      $('[data-out="bar"]').style.width = pct.toFixed(1) + '%';
      $('[data-out="barsub"]').textContent = `${pct.toFixed(1)}% of the way there.`;

      // chart: portfolio over time vs. FIRE target line
      var labels = [], port = [], target = [];
      for (var yr = 0; yr <= Math.max(40, (s.targetAge - s.currentAge)); yr++) {
        labels.push(s.currentAge + yr);
        port.push(this.project(yr, s.currentSav, s.monthlySav, growthRate));
        target.push(fire);
      }
      this.draw(labels, port, target);
      IT.url.write({ exp: s.monthlyExp, rr: s.retRate, ca: s.currentAge, ta: s.targetAge, cs: s.currentSav, ms: s.monthlySav });
    }
    draw(labels, port, target) {
      if (!window.Chart) { setTimeout(() => this.draw(labels, port, target), 200); return; }
      var ctx = this.el.querySelector('#fire-chart');
      if (this._chart) this._chart.destroy();
      var T = window.IT_TOKENS;
      this._chart = new Chart(ctx, {
        type: 'line',
        data: { labels: labels, datasets: [
          { label: 'Portfolio',   data: port,   borderColor: T.coral, backgroundColor: T.coralFill, fill: true, borderWidth: 2, pointRadius: 0, tension: 0.2 },
          { label: 'FIRE Target', data: target, borderColor: T.yellow, borderDash: [4, 4], borderWidth: 2, fill: false, pointRadius: 0 }
        ]},
        options: { responsive: true, maintainAspectRatio: false,
          scales: {
            x: { title: { display: true, text: 'Age' } },
            y: { ticks: { callback: v => v >= 1e6 ? '$' + (v/1e6).toFixed(1) + 'M' : '$' + (v/1000).toFixed(0) + 'k' } }
          }
        }
      });
    }
  }
  document.addEventListener('DOMContentLoaded', () => new FireNumber('simulator-container'));
})();
